import ToggleCheckboxController from "../../../../../javascript/stimulusControllers/shared/toggle-checkbox-controller"

export default class extends ToggleCheckboxController {}



// WEBPACK FOOTER //
// ./app/components/forms/checkboxes/assets/javascript/forms-checkboxes-app-checkbox-controller.js